import { render, staticRenderFns } from "./SingleWrapper.vue?vue&type=template&id=ae84dd18&"
import script from "./SingleWrapper.vue?vue&type=script&lang=ts&"
export * from "./SingleWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SingleWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports